import { defineAction } from '~/prix'
import { featureCollection, geometry, multiPolygon, polygon } from '~/prix/types/presets/geo'
import neighborhoodEditCoverageAreaAction from './neighborhoodEditCoverageArea.action.json' with { type: 'json' }
import { z } from 'zod'

const neighborhoodEditCoverageAreaDefinition = defineAction({
  ...neighborhoodEditCoverageAreaAction,

  input: z.object({
    delimitationPolygon: multiPolygon(),
    delimitationId: z.number(),
    delimitationType: z.enum(['municipality']),
    featureCollection: featureCollection(
      geometry().nullable(),
      z.object({
        key: z.string(),
        id: z.number().or(z.string()).nullish(),
        name: z.string(),
        alternativeNames: z.array(z.string()).nullish(),
        kind: z
          .enum([
            'smartMapping',
            'deprecated',
            'manualDrawing',
            'authorityProvided',
            'openStreetMapSourced',
          ])
          .nullish(),
        municipalityId: z.number(),
        isCommunity: z.boolean().nullish(),
      }),
    ),
  }),
  output: z.object({
    success: z.boolean(),
  }),
})

export default neighborhoodEditCoverageAreaDefinition
